import React from 'react';

const LoadingIcon = () => {
  return (
    <svg width="201" height="201" viewBox="0 0 201 201" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M76.654 191.751c-50.133-13.433-79.883-64.963-66.45-115.096 13.433-50.133 64.963-79.883 115.095-66.45 50.133 13.432 79.884 64.963 66.451 115.095-13.433 50.133-64.963 79.884-115.096 66.451z"
        stroke="url(#fuuo15ft6a)"
        strokeWidth="12"
      />
      <defs>
        <linearGradient id="fuuo15ft6a" x1="127.638" y1="149.854" x2="4.409" y2="75.102" gradientUnits="userSpaceOnUse">
          <stop stopColor="#0098A1" />
          <stop offset="1" stopColor="#96BE0D" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default LoadingIcon;
